// import React, { useRef, useEffect, useState, useCallback } from 'react';
// import { Button, Typography, Progress } from 'antd'; // Still need Ant Design imports for the main UI

// // --- Ant Design Destructuring ---
// const { Text, Title } = Typography;

// // --- Global Constants ---
// const GAME_CANVAS_W = 900;
// const GAME_CANVAS_H = 740;
// const PREVIEW_W = 280;
// const PREVIEW_H = 210;
// const POSE_CONFIDENCE_THRESHOLD = 0.5;
// const PLAYER_RADIUS = 40;
// const PROJECTILE_RADIUS = 30;
// const INITIAL_SPAWN_INTERVAL = 2000; // ms
// const MIN_SPAWN_INTERVAL = 500;
// const SPAWN_DECREASE_RATE = 100; // decrease by 100ms every 5 points
// const HEALTH_LOSS = 10; // Health lost per hit

// // --- Main Component ---
// export default function DodgeAndWeave() {
//   const videoRef = useRef(null);
//   const previewVideoRef = useRef(null);
//   const canvasRef = useRef(null);
//   const rafRef = useRef(null);
//   const poseEstimatorRef = useRef(null);
//   const lastSpawnTimeRef = useRef(0);
//   const spawnIntervalRef = useRef(INITIAL_SPAWN_INTERVAL);
//   const animationStartedRef = useRef(false);

//   // State Management
//   const [gameState, setGameState] = useState('ready');
//   const [score, setScore] = useState(0);
//   const [health, setHealth] = useState(100);
//   const [status, setStatus] = useState("Ready – Click Start to begin.");
//   const [difficulty, setDifficulty] = useState(1);
//   const [mediaPipeLoaded, setMediaPipeLoaded] = useState(false); // KEY: Tracks script loading

//   // Ref to hold game data and transient state for use in the animation loop
//   const gameDataRef = useRef({
//     player: { x: GAME_CANVAS_W / 2, y: GAME_CANVAS_H / 2, visible: false },
//     projectiles: [],
//     particles: [],
//     dodgeStreak: 0,
//     // Synchronized state values for the game loop
//     currentScore: 0,
//     currentHealth: 100,
//     currentDifficulty: 1,
//     currentGameState: 'ready',
//   });

//   // Effect to synchronize React state with ref values for the game loop
//   useEffect(() => {
//     gameDataRef.current.currentScore = score;
//     gameDataRef.current.currentHealth = health;
//     gameDataRef.current.currentDifficulty = difficulty;
//     gameDataRef.current.currentGameState = gameState;
//   }, [score, health, difficulty, gameState]);


//   // --- Create Hit Effect ---
//   const createHitEffect = (x, y) => {
//     for (let i = 0; i < 15; i++) {
//       const angle = (Math.PI * 2 * i) / 15;
//       const speed = 2 + Math.random() * 4;
//       gameDataRef.current.particles.push({
//         x, y,
//         vx: Math.cos(angle) * speed,
//         vy: Math.sin(angle) * speed,
//         radius: 3 + Math.random() * 5,
//         color: '#ff4444',
//         life: 1,
//       });
//     }
//   };

//   // --- Spawn Projectile ---
//   const spawnProjectile = useCallback(() => {
//     const { player } = gameDataRef.current;
//     if (!player.visible) return;

//     const side = Math.floor(Math.random() * 4);
//     let startX, startY;

//     if (side === 0) { startX = Math.random() * GAME_CANVAS_W; startY = -PROJECTILE_RADIUS; }
//     else if (side === 1) { startX = GAME_CANVAS_W + PROJECTILE_RADIUS; startY = Math.random() * GAME_CANVAS_H; }
//     else if (side === 2) { startX = Math.random() * GAME_CANVAS_W; startY = GAME_CANVAS_H + PROJECTILE_RADIUS; }
//     else { startX = -PROJECTILE_RADIUS; startY = Math.random() * GAME_CANVAS_H; }

//     const targetX = player.x;
//     const targetY = player.y;

//     const dx = targetX - startX;
//     const dy = targetY - startY;
//     const distance = Math.sqrt(dx * dx + dy * dy);
//     const speed = 3 + (gameDataRef.current.currentDifficulty * 0.5);

//     const newProjectile = {
//       x: startX, y: startY,
//       vx: (dx / distance) * speed,
//       vy: (dy / distance) * speed,
//       radius: PROJECTILE_RADIUS,
//       color: `hsl(${Math.random() * 360}, 70%, 50%)`,
//       active: true,
//     };

//     gameDataRef.current.projectiles.push(newProjectile);
//   }, []);

//   // --- MediaPipe Setup ---
//   const setupMediaPipe = useCallback(async () => {
//     if (!window.Pose || !window.Camera) {
//       console.error("MediaPipe libraries not loaded.");
//       setStatus("Error: MediaPipe libraries were not found.");
//       return;
//     }

//     try {
//       const pose = new window.Pose({
//         locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.5/${file}`,
//       });

//       pose.setOptions({
//         modelComplexity: 1,
//         smoothLandmarks: true,
//         minDetectionConfidence: POSE_CONFIDENCE_THRESHOLD,
//         minTrackingConfidence: POSE_CONFIDENCE_THRESHOLD,
//       });

//       pose.onResults((results) => {
//         const nose = results.poseLandmarks?.[0];

//         if (nose && nose.visibility > POSE_CONFIDENCE_THRESHOLD) {
//           const newX = (1 - nose.x) * GAME_CANVAS_W;
//           const newY = nose.y * GAME_CANVAS_H;

//           gameDataRef.current.player = { x: newX, y: newY, visible: true };
//         } else {
//           gameDataRef.current.player.visible = false;
//         }
//       });

//       poseEstimatorRef.current = pose;

//       const stream = await navigator.mediaDevices.getUserMedia({
//         video: { width: { ideal: 640 }, height: { ideal: 480 }, facingMode: 'user' }
//       });

//       videoRef.current.srcObject = stream;
//       previewVideoRef.current.srcObject = stream;

//       videoRef.current.onloadedmetadata = () => {
//         videoRef.current.play();
//         previewVideoRef.current.play();

//         const camera = new window.Camera(videoRef.current, {
//           onFrame: async () => {
//             if (poseEstimatorRef.current) {
//               await poseEstimatorRef.current.send({ image: videoRef.current });
//             }
//           },
//           width: 640,
//           height: 480,
//         });
//         camera.start();
//         setStatus("Camera ready! Click Start Game.");

//         if (!animationStartedRef.current) {
//           animationStartedRef.current = true;
//           gameLoop();
//         }
//       };
//     } catch (err) {
//       console.error("Camera access error:", err);
//       setStatus("Error: Camera access denied. Please allow camera access in your browser settings.");
//     }
//   }, []);

//   // --- Game Loop Logic ---
//   const gameLoopLogic = () => {
//     const ctx = canvasRef.current?.getContext('2d');
//     if (!ctx) return;

//     const { player, projectiles, particles } = gameDataRef.current;
//     const currentGameState = gameDataRef.current.currentGameState;

//     // --- Drawing (Background and Grid) ---
//     ctx.clearRect(0, 0, GAME_CANVAS_W, GAME_CANVAS_H);
//     const gradient = ctx.createLinearGradient(0, 0, 0, GAME_CANVAS_H);
//     gradient.addColorStop(0, '#0f172a');
//     gradient.addColorStop(1, '#1e293b');
//     ctx.fillStyle = gradient;
//     ctx.fillRect(0, 0, GAME_CANVAS_W, GAME_CANVAS_H);
//     ctx.strokeStyle = 'rgba(100, 116, 139, 0.2)';
//     ctx.lineWidth = 1;
//     for (let i = 0; i < GAME_CANVAS_W; i += 50) { ctx.beginPath(); ctx.moveTo(i, 0); ctx.lineTo(i, GAME_CANVAS_H); ctx.stroke(); }
//     for (let i = 0; i < GAME_CANVAS_H; i += 50) { ctx.beginPath(); ctx.moveTo(0, i); ctx.lineTo(GAME_CANVAS_W, i); ctx.stroke(); }

//     // --- Particles ---
//     for (let i = particles.length - 1; i >= 0; i--) {
//       const p = particles[i];
//       p.x += p.vx; p.y += p.vy; p.vy += 0.1; p.life -= 0.02;
//       if (p.life <= 0) { particles.splice(i, 1); continue; }
//       ctx.globalAlpha = p.life; ctx.beginPath(); ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2); ctx.fillStyle = p.color; ctx.fill();
//     }
//     ctx.globalAlpha = 1;

//     // --- Projectile Spawning ---
//     if (currentGameState === 'playing') {
//       const now = Date.now();
//       if (now - lastSpawnTimeRef.current > spawnIntervalRef.current) {
//         spawnProjectile();
//         lastSpawnTimeRef.current = now;
//       }
//     }

//     // --- Projectile Update/Draw/Collision ---
//     for (let i = projectiles.length - 1; i >= 0; i--) {
//       const proj = projectiles[i];
//       if (!proj.active) continue;

//       proj.x += proj.vx;
//       proj.y += proj.vy;

//       // Dodge success (out of bounds)
//       if (proj.x < -proj.radius * 2 || proj.x > GAME_CANVAS_W + proj.radius * 2 ||
//           proj.y < -proj.radius * 2 || proj.y > GAME_CANVAS_H + proj.radius * 2) {
//         projectiles.splice(i, 1);

//         if (currentGameState === 'playing') {
//           setScore(s => s + 1);
//           gameDataRef.current.dodgeStreak += 1;

//           if (gameDataRef.current.dodgeStreak % 5 === 0) {
//             setDifficulty(d => d + 1);
//             spawnIntervalRef.current = Math.max(MIN_SPAWN_INTERVAL, spawnIntervalRef.current - SPAWN_DECREASE_RATE);
//           }
//         }
//         continue;
//       }

//       // Collision check
//       if (player.visible && currentGameState === 'playing') {
//         const dx = player.x - proj.x;
//         const dy = player.y - proj.y;
//         const distance = Math.sqrt(dx * dx + dy * dy);

//         if (distance < PLAYER_RADIUS + proj.radius) {
//           proj.active = false;
//           projectiles.splice(i, 1);
//           createHitEffect(proj.x, proj.y);

//           setHealth(h => {
//             const newHealth = Math.max(0, h - HEALTH_LOSS);
//             if (newHealth <= 0) {
//               setGameState('finished');
//               setStatus(`Game Over! You dodged ${gameDataRef.current.currentScore} projectiles!`);
//             }
//             return newHealth;
//           });

//           gameDataRef.current.dodgeStreak = 0;
//           continue;
//         }
//       }

//       // Draw projectile (with glow and highlight)
//       ctx.save();
//       ctx.beginPath();
//       ctx.arc(proj.x, proj.y, proj.radius + 5, 0, Math.PI * 2);
//       const glowGradient = ctx.createRadialGradient(proj.x, proj.y, 0, proj.x, proj.y, proj.radius + 5);
//       glowGradient.addColorStop(0, proj.color);
//       glowGradient.addColorStop(1, 'rgba(0, 0, 0, 0)');
//       ctx.fillStyle = glowGradient;
//       ctx.fill();
//       ctx.beginPath();
//       ctx.arc(proj.x, proj.y, proj.radius, 0, Math.PI * 2);
//       const projGradient = ctx.createRadialGradient(proj.x - proj.radius * 0.3, proj.y - proj.radius * 0.3, 0, proj.x, proj.y, proj.radius);
//       projGradient.addColorStop(0, '#fff');
//       projGradient.addColorStop(0.5, proj.color);
//       projGradient.addColorStop(1, '#000');
//       ctx.fillStyle = projGradient;
//       ctx.fill();
//       ctx.beginPath();
//       ctx.arc(proj.x - proj.radius * 0.3, proj.y - proj.radius * 0.3, proj.radius * 0.3, 0, Math.PI * 2);
//       ctx.fillStyle = 'rgba(255, 255, 255, 0.6)';
//       ctx.fill();
//       ctx.restore();
//     }

//     // --- Draw Player ---
//     if (player.visible) {
//       ctx.save();
//       ctx.beginPath();
//       ctx.arc(player.x, player.y, PLAYER_RADIUS + 10, 0, Math.PI * 2);
//       const playerGlow = ctx.createRadialGradient(player.x, player.y, 0, player.x, player.y, PLAYER_RADIUS + 10);
//       playerGlow.addColorStop(0, 'rgba(59, 130, 246, 0.5)');
//       playerGlow.addColorStop(1, 'rgba(59, 130, 246, 0)');
//       ctx.fillStyle = playerGlow;
//       ctx.fill();
//       ctx.beginPath();
//       ctx.arc(player.x, player.y, PLAYER_RADIUS, 0, Math.PI * 2);
//       const playerGradient = ctx.createRadialGradient(player.x - PLAYER_RADIUS * 0.3, player.y - PLAYER_RADIUS * 0.3, 0, player.x, player.y, PLAYER_RADIUS);
//       playerGradient.addColorStop(0, '#60a5fa');
//       playerGradient.addColorStop(1, '#3b82f6');
//       ctx.fillStyle = playerGradient;
//       ctx.fill();
//       ctx.strokeStyle = '#fff';
//       ctx.lineWidth = 3;
//       ctx.stroke();
//       ctx.beginPath();
//       ctx.arc(player.x - PLAYER_RADIUS * 0.3, player.y - PLAYER_RADIUS * 0.3, PLAYER_RADIUS * 0.25, 0, Math.PI * 2);
//       ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
//       ctx.fill();
//       ctx.restore();
//     }

//     // --- Draw Indicators/Overlays ---
//     if (gameDataRef.current.dodgeStreak > 0 && currentGameState === 'playing') {
//       ctx.fillStyle = '#4ade80';
//       ctx.font = 'bold 24px Arial';
//       ctx.textAlign = 'center';
//       ctx.fillText(`${gameDataRef.current.dodgeStreak} Streak! 🔥`, GAME_CANVAS_W / 2, 40);
//     }

//     // Debug Info
//     ctx.fillStyle = '#fff';
//     ctx.font = '14px Arial';
//     ctx.textAlign = 'left';
//     ctx.fillText(`Player: (${Math.round(player.x)}, ${Math.round(player.y)}) Visible: ${player.visible ? 'Yes' : 'No'}`, 10, 20);
//     ctx.fillText(`Projectiles: ${projectiles.length}`, 10, 40);
//     ctx.fillText(`Game State: ${currentGameState}`, 10, 60);

//     // Game Over Overlay
//     if (currentGameState === 'finished') {
//       ctx.fillStyle = 'rgba(0, 0, 0, 0.85)';
//       ctx.fillRect(0, 0, GAME_CANVAS_W, GAME_CANVAS_H);

//       ctx.fillStyle = '#ff4444';
//       ctx.font = 'bold 64px Arial';
//       ctx.textAlign = 'center';
//       ctx.textBaseline = 'middle';
//       ctx.shadowColor = 'rgba(255, 68, 68, 0.5)';
//       ctx.shadowBlur = 20;
//       ctx.fillText('GAME OVER', GAME_CANVAS_W / 2, GAME_CANVAS_H / 2 - 60);
//       ctx.shadowBlur = 0;

//       ctx.font = 'bold 36px Arial';
//       ctx.fillStyle = '#4ade80';
//       ctx.shadowColor = 'rgba(74, 222, 128, 0.5)';
//       ctx.shadowBlur = 15;
//       ctx.fillText(`Dodged: ${gameDataRef.current.currentScore} projectiles`, GAME_CANVAS_W / 2, GAME_CANVAS_H / 2 + 20);
//       ctx.shadowBlur = 0;

//       ctx.font = '24px Arial';
//       ctx.fillStyle = '#fff';
//       ctx.fillText('Click "PLAY AGAIN" to restart', GAME_CANVAS_W / 2, GAME_CANVAS_H / 2 + 80);
//     }
//   };

//   // --- Game Loop ---
//   const gameLoop = () => {
//     gameLoopLogic();
//     rafRef.current = requestAnimationFrame(gameLoop);
//   };

//   // --- Game Control ---
//   const handleStartGame = () => {
//     if (gameState === 'playing' || !mediaPipeLoaded) return;

//     setScore(0);
//     setHealth(100);
//     setDifficulty(1);
//     setGameState('playing');

//     gameDataRef.current.projectiles = [];
//     gameDataRef.current.particles = [];
//     gameDataRef.current.dodgeStreak = 0;
//     lastSpawnTimeRef.current = Date.now();
//     spawnIntervalRef.current = INITIAL_SPAWN_INTERVAL;

//     setStatus("Dodge incoming projectiles! Move your body to avoid them!");
//   };

//   // --- Effects (Script Loading and Cleanup) ---
//   useEffect(() => {
//     const loadScript = (src) => {
//       return new Promise((resolve, reject) => {
//         const script = document.createElement('script');
//         script.src = src;
//         script.onload = resolve;
//         script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
//         document.body.appendChild(script);
//       });
//     };

//     const loadMediaPipe = async () => {
//       try {
//         setStatus("Loading MediaPipe libraries...");
//         await loadScript('https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.5/pose.js');
//         await loadScript('https://cdn.jsdelivr.net/npm/@mediapipe/camera_utils@0.1/camera_utils.js');

//         // Scripts are loaded, now set the flag to render the main UI
//         setMediaPipeLoaded(true);
//         setStatus("Libraries loaded. Requesting camera access...");
//         setupMediaPipe();
//       } catch (error) {
//         console.error("MediaPipe Loading Error:", error);
//         setStatus(`Error loading required libraries. Check your connection or console.`);
//       }
//     };

//     loadMediaPipe();

//     // --- CLEANUP FUNCTION (Crucial for preventing resource leaks) ---
//     return () => {
//       if (rafRef.current) {
//         cancelAnimationFrame(rafRef.current);
//       }
//       if (videoRef.current?.srcObject) {
//         videoRef.current.srcObject.getTracks().forEach(track => track.stop());
//       }
//       if (poseEstimatorRef.current) {
//         poseEstimatorRef.current.close();
//       }
//     };
//   }, [setupMediaPipe]);

//   // --- Render ---
//   return (
//     <div style={{
//       display: 'flex',
//       minHeight: '100vh',
//       background: '#0f172a',
//       color: '#fff',
//       fontFamily: 'Arial, sans-serif'
//     }}>

//       {/* Hidden Video element used by MediaPipe to capture frames */}
//       <video ref={videoRef} style={{ display: 'none' }} playsInline muted />

//       {/* RENDER FIX: Use simple HTML for the loading screen to avoid Ant Design component initialization errors */}
//       {!mediaPipeLoaded ? (
//         <div style={{
//           flex: 1,
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           flexDirection: 'column',
//           padding: 50,
//         }}>
//           {/* Using raw HTML headings/text here */}
//           <h2 style={{ color: '#fff', fontSize: '2em' }}>Loading Game Resources...</h2>
//           <p style={{ color: '#94a3b8' }}>{status}</p>
//           {/* Using a basic Ant Design progress circle is usually safe, but use <Progress> cautiously */}
//           <Progress type="circle" percent={100} width={80} status="active" style={{ marginTop: 20 }} />
//         </div>
//       ) : (
//         <>
//           {/* LEFT PANEL */}
//           <div style={{
//             width: 320,
//             background: '#1e293b',
//             padding: 16,
//             boxShadow: '4px 0 10px rgba(0,0,0,0.5)'
//           }}>
//             <Title level={3} style={{ color: '#f43f5e', marginTop: 0, marginBottom: 16 }}>
//               🎯 Dodge & Weave
//             </Title>

//             <Text style={{
//               fontSize: 14,
//               fontWeight: 'bold',
//               color: '#e2e8f0',
//               display: 'block',
//               marginBottom: 16
//             }}>
//               {status}
//             </Text>

//             <div style={{ margin: '16px 0' }}>
//               <Text style={{ color: '#94a3b8', fontSize: 12 }}>Health</Text>
//               <Progress
//                 percent={health}
//                 strokeColor={{
//                   '0%': '#ef4444',
//                   '50%': '#f59e0b',
//                   '100%': '#22c55e',
//                 }}
//                 status={health > 0 && gameState === 'playing' ? 'active' : health <= 0 ? 'exception' : 'normal'}
//               />
//             </div>

//             <Button
//               onClick={handleStartGame}
//               disabled={gameState === 'playing'}
//               type="primary"
//               danger
//               block
//               size="large"
//               style={{ fontWeight: 'bold', marginBottom: 16 }}
//             >
//               {gameState === 'ready' || gameState === 'finished' ? 'START GAME' : 'PLAYING...'}
//             </Button>

//             <div style={{
//               background: 'rgba(15, 23, 42, 0.5)', padding: 12, borderRadius: 8, marginBottom: 16
//             }}>
//               <div style={{ color: '#4ade80', fontSize: 32, fontWeight: 'bold', textAlign: 'center' }}>
//                 {score}
//               </div>
//               <Text style={{ color: '#94a3b8', fontSize: 12, display: 'block', textAlign: 'center' }}>
//                 Projectiles Dodged
//               </Text>
//             </div>

//             <div style={{
//               background: 'rgba(244, 63, 94, 0.2)', padding: 12, borderRadius: 8, marginBottom: 16, border: '1px solid rgba(244, 63, 94, 0.3)'
//             }}>
//               <Text style={{ color: '#f43f5e', fontSize: 20, fontWeight: 'bold', display: 'block', textAlign: 'center' }}>
//                 Level {difficulty}
//               </Text>
//               <Text style={{ color: '#94a3b8', fontSize: 12, display: 'block', textAlign: 'center' }}>
//                 Difficulty
//               </Text>
//             </div>

//             <Text style={{ color: '#64748b', fontSize: 12, display: 'block', marginBottom: 8 }}>
//               Camera Preview:
//             </Text>

//             <div style={{
//               width: PREVIEW_W, height: PREVIEW_H, border: '2px solid #334155', borderRadius: '8px', overflow: 'hidden', background: '#000', marginBottom: 16
//             }}>
//               <video
//                 ref={previewVideoRef}
//                 style={{ transform: 'scaleX(-1)', width: '100%', height: '100%' }}
//                 playsInline
//                 muted
//               />
//             </div>

//             <div style={{
//               background: 'rgba(59, 130, 246, 0.1)', padding: 12, borderRadius: 8, border: '1px solid rgba(59, 130, 246, 0.3)'
//             }}>
//               <Text style={{ color: '#60a5fa', display: 'block', fontWeight: 'bold', marginBottom: 8, fontSize: 13 }}>
//                 How to Play:
//               </Text>
//               <Text style={{ color: '#cbd5e1', display: 'block', marginBottom: 4, fontSize: 12 }}>
//                 • Move your **HEAD** (tracked by the blue circle)
//               </Text>
//               <Text style={{ color: '#cbd5e1', display: 'block', marginBottom: 4, fontSize: 12 }}>
//                 • **LEAN** and **DUCK** to dodge projectiles
//               </Text>
//               <Text style={{ color: '#cbd5e1', display: 'block', marginBottom: 4, fontSize: 12 }}>
//                 • Each dodge = **1 point**
//               </Text>
//               <Text style={{ color: '#cbd5e1', display: 'block', fontSize: 12 }}>
//                 • Getting hit = **-10 health**
//               </Text>
//             </div>
//           </div>

//           {/* RIGHT PANEL - GAME AREA */}
//           <div style={{
//             flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 20
//           }}>
//             <div style={{
//               position: 'relative', width: GAME_CANVAS_W, height: GAME_CANVAS_H, boxShadow: '0 0 40px rgba(244, 63, 94, 0.3)', borderRadius: '12px', overflow: 'hidden', border: '2px solid rgba(244, 63, 94, 0.5)'
//             }}>
//               <canvas
//                 ref={canvasRef}
//                 width={GAME_CANVAS_W}
//                 height={GAME_CANVAS_H}
//                 style={{ borderRadius: '12px' }}
//               />
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

import React, { useRef, useEffect, useState, useCallback } from 'react';
import { Button, Typography, Progress } from 'antd'; // Still need Ant Design imports for the main UI

// --- Ant Design Destructuring ---
const { Text, Title } = Typography;

// --- Global Constants ---
const GAME_CANVAS_W = 900;
const GAME_CANVAS_H = 740;
const PREVIEW_W = 280;
const PREVIEW_H = 210;
const POSE_CONFIDENCE_THRESHOLD = 0.5;
const PLAYER_RADIUS = 40;
const PROJECTILE_RADIUS = 30;
const INITIAL_SPAWN_INTERVAL = 2000; // ms
const MIN_SPAWN_INTERVAL = 500;
const SPAWN_DECREASE_RATE = 100; // decrease by 100ms every 5 points
const HEALTH_LOSS = 10; // Health lost per hit

// --- Main Component ---
export default function DodgeAndWeave() {
  const videoRef = useRef(null);
  const previewVideoRef = useRef(null);
  const canvasRef = useRef(null);
  const rafRef = useRef(null);
  const poseEstimatorRef = useRef(null);
  const lastSpawnTimeRef = useRef(0);
  const spawnIntervalRef = useRef(INITIAL_SPAWN_INTERVAL);
  const animationStartedRef = useRef(false);

  // State Management
  const [gameState, setGameState] = useState('ready');
  const [score, setScore] = useState(0);
  const [health, setHealth] = useState(100);
  const [status, setStatus] = useState("Ready – Click Start to begin.");
  const [difficulty, setDifficulty] = useState(1);
  const [mediaPipeLoaded, setMediaPipeLoaded] = useState(false); // KEY: Tracks script loading

  // Ref to hold game data and transient state for use in the animation loop
  const gameDataRef = useRef({
    player: { x: GAME_CANVAS_W / 2, y: GAME_CANVAS_H / 2, visible: false },
    projectiles: [],
    particles: [],
    dodgeStreak: 0,
    levelDodges: 0, // Track dodges for current level
    // Synchronized state values for the game loop
    currentScore: 0,
    currentHealth: 100,
    currentDifficulty: 1,
    currentGameState: 'ready',
  });

  // Effect to synchronize React state with ref values for the game loop
  useEffect(() => {
    gameDataRef.current.currentScore = score;
    gameDataRef.current.currentHealth = health;
    gameDataRef.current.currentDifficulty = difficulty;
    gameDataRef.current.currentGameState = gameState;
  }, [score, health, difficulty, gameState]);


  // --- Create Hit Effect ---
  const createHitEffect = (x, y) => {
    for (let i = 0; i < 15; i++) {
      const angle = (Math.PI * 2 * i) / 15;
      const speed = 2 + Math.random() * 4;
      gameDataRef.current.particles.push({
        x, y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        radius: 3 + Math.random() * 5,
        color: '#ff4444',
        life: 1,
      });
    }
  };

  // --- Spawn Projectile ---
  const spawnProjectile = useCallback(() => {
    const { player } = gameDataRef.current;
    if (!player.visible) return;

    const side = Math.floor(Math.random() * 4);
    let startX, startY;

    if (side === 0) { startX = Math.random() * GAME_CANVAS_W; startY = -PROJECTILE_RADIUS; }
    else if (side === 1) { startX = GAME_CANVAS_W + PROJECTILE_RADIUS; startY = Math.random() * GAME_CANVAS_H; }
    else if (side === 2) { startX = Math.random() * GAME_CANVAS_W; startY = GAME_CANVAS_H + PROJECTILE_RADIUS; }
    else { startX = -PROJECTILE_RADIUS; startY = Math.random() * GAME_CANVAS_H; }

    const targetX = player.x;
    const targetY = player.y;

    const dx = targetX - startX;
    const dy = targetY - startY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const speed = 3 + (gameDataRef.current.currentDifficulty * 0.5);

    const newProjectile = {
      x: startX, y: startY,
      vx: (dx / distance) * speed,
      vy: (dy / distance) * speed,
      radius: PROJECTILE_RADIUS,
      color: `hsl(${Math.random() * 360}, 70%, 50%)`,
      active: true,
    };

    gameDataRef.current.projectiles.push(newProjectile);
  }, []);

  // --- MediaPipe Setup ---
  const setupMediaPipe = useCallback(async () => {
    if (!window.Pose || !window.Camera) {
      console.error("MediaPipe libraries not loaded.");
      setStatus("Error: MediaPipe libraries were not found.");
      return;
    }

    try {
      const pose = new window.Pose({
        locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.5/${file}`,
      });

      pose.setOptions({
        modelComplexity: 1,
        smoothLandmarks: true,
        minDetectionConfidence: POSE_CONFIDENCE_THRESHOLD,
        minTrackingConfidence: POSE_CONFIDENCE_THRESHOLD,
      });

      pose.onResults((results) => {
        const nose = results.poseLandmarks?.[0];

        if (nose && nose.visibility > POSE_CONFIDENCE_THRESHOLD) {
          const newX = (1 - nose.x) * GAME_CANVAS_W;
          const newY = nose.y * GAME_CANVAS_H;

          gameDataRef.current.player = { x: newX, y: newY, visible: true };
        } else {
          gameDataRef.current.player.visible = false;
        }
      });

      poseEstimatorRef.current = pose;

      const stream = await navigator.mediaDevices.getUserMedia({
        video: { width: { ideal: 640 }, height: { ideal: 480 }, facingMode: 'user' }
      });

      videoRef.current.srcObject = stream;
      previewVideoRef.current.srcObject = stream;

      videoRef.current.onloadedmetadata = () => {
        videoRef.current.play();
        previewVideoRef.current.play();

        const camera = new window.Camera(videoRef.current, {
          onFrame: async () => {
            if (poseEstimatorRef.current) {
              await poseEstimatorRef.current.send({ image: videoRef.current });
            }
          },
          width: 640,
          height: 480,
        });
        camera.start();
        setStatus("Camera ready! Click Start Game.");

        if (!animationStartedRef.current) {
          animationStartedRef.current = true;
          gameLoop();
        }
      };
    } catch (err) {
      console.error("Camera access error:", err);
      setStatus("Error: Camera access denied. Please allow camera access in your browser settings.");
    }
  }, []);

  // --- Game Loop Logic ---
  const gameLoopLogic = () => {
    const ctx = canvasRef.current?.getContext('2d');
    if (!ctx) return;

    const { player, projectiles, particles } = gameDataRef.current;
    const currentGameState = gameDataRef.current.currentGameState;

    // --- Drawing (Background and Grid) ---
    ctx.clearRect(0, 0, GAME_CANVAS_W, GAME_CANVAS_H);
    const gradient = ctx.createLinearGradient(0, 0, 0, GAME_CANVAS_H);
    gradient.addColorStop(0, '#0f172a');
    gradient.addColorStop(1, '#1e293b');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, GAME_CANVAS_W, GAME_CANVAS_H);
    ctx.strokeStyle = 'rgba(100, 116, 139, 0.2)';
    ctx.lineWidth = 1;
    for (let i = 0; i < GAME_CANVAS_W; i += 50) { ctx.beginPath(); ctx.moveTo(i, 0); ctx.lineTo(i, GAME_CANVAS_H); ctx.stroke(); }
    for (let i = 0; i < GAME_CANVAS_H; i += 50) { ctx.beginPath(); ctx.moveTo(0, i); ctx.lineTo(GAME_CANVAS_W, i); ctx.stroke(); }

    // --- Particles ---
    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.x += p.vx; p.y += p.vy; p.vy += 0.1; p.life -= 0.02;
      if (p.life <= 0) { particles.splice(i, 1); continue; }
      ctx.globalAlpha = p.life; ctx.beginPath(); ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2); ctx.fillStyle = p.color; ctx.fill();
    }
    ctx.globalAlpha = 1;

    // --- Projectile Spawning (Multiple projectiles per level) ---
    if (currentGameState === 'playing') {
      const now = Date.now();
      if (now - lastSpawnTimeRef.current > spawnIntervalRef.current) {
        // Spawn number of projectiles equal to current difficulty level
        const numToSpawn = Math.min(gameDataRef.current.currentDifficulty, 5); // Cap at 5 max
        for (let i = 0; i < numToSpawn; i++) {
          spawnProjectile();
        }
        lastSpawnTimeRef.current = now;
      }
    }

    // --- Projectile Update/Draw/Collision ---
    for (let i = projectiles.length - 1; i >= 0; i--) {
      const proj = projectiles[i];
      if (!proj.active) continue;

      proj.x += proj.vx;
      proj.y += proj.vy;

      // Dodge success (out of bounds)
      if (proj.x < -proj.radius * 2 || proj.x > GAME_CANVAS_W + proj.radius * 2 ||
          proj.y < -proj.radius * 2 || proj.y > GAME_CANVAS_H + proj.radius * 2) {
        projectiles.splice(i, 1);

        if (currentGameState === 'playing') {
          setScore(s => s + 1);
          gameDataRef.current.dodgeStreak += 1;
          gameDataRef.current.levelDodges += 1;

          // Check if player has dodged 10 projectiles in current level
          if (gameDataRef.current.levelDodges >= 10) {
            setDifficulty(d => d + 1);
            gameDataRef.current.levelDodges = 0; // Reset level dodge counter
            spawnIntervalRef.current = Math.max(MIN_SPAWN_INTERVAL, spawnIntervalRef.current - SPAWN_DECREASE_RATE);
          }
        }
        continue;
      }

      // Collision check
      if (player.visible && currentGameState === 'playing') {
        const dx = player.x - proj.x;
        const dy = player.y - proj.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance < PLAYER_RADIUS + proj.radius) {
          proj.active = false;
          projectiles.splice(i, 1);
          createHitEffect(proj.x, proj.y);

          setHealth(h => {
            const newHealth = Math.max(0, h - HEALTH_LOSS);
            if (newHealth <= 0) {
              setGameState('finished');
              setStatus(`Game Over! You dodged ${gameDataRef.current.currentScore} projectiles!`);
            }
            return newHealth;
          });

          gameDataRef.current.dodgeStreak = 0;
          continue;
        }
      }

      // Draw projectile (with glow and highlight)
      ctx.save();
      ctx.beginPath();
      ctx.arc(proj.x, proj.y, proj.radius + 5, 0, Math.PI * 2);
      const glowGradient = ctx.createRadialGradient(proj.x, proj.y, 0, proj.x, proj.y, proj.radius + 5);
      glowGradient.addColorStop(0, proj.color);
      glowGradient.addColorStop(1, 'rgba(0, 0, 0, 0)');
      ctx.fillStyle = glowGradient;
      ctx.fill();
      ctx.beginPath();
      ctx.arc(proj.x, proj.y, proj.radius, 0, Math.PI * 2);
      const projGradient = ctx.createRadialGradient(proj.x - proj.radius * 0.3, proj.y - proj.radius * 0.3, 0, proj.x, proj.y, proj.radius);
      projGradient.addColorStop(0, '#fff');
      projGradient.addColorStop(0.5, proj.color);
      projGradient.addColorStop(1, '#000');
      ctx.fillStyle = projGradient;
      ctx.fill();
      ctx.beginPath();
      ctx.arc(proj.x - proj.radius * 0.3, proj.y - proj.radius * 0.3, proj.radius * 0.3, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255, 255, 255, 0.6)';
      ctx.fill();
      ctx.restore();
    }

    // --- Draw Player ---
    if (player.visible) {
      ctx.save();
      ctx.beginPath();
      ctx.arc(player.x, player.y, PLAYER_RADIUS + 10, 0, Math.PI * 2);
      const playerGlow = ctx.createRadialGradient(player.x, player.y, 0, player.x, player.y, PLAYER_RADIUS + 10);
      playerGlow.addColorStop(0, 'rgba(59, 130, 246, 0.5)');
      playerGlow.addColorStop(1, 'rgba(59, 130, 246, 0)');
      ctx.fillStyle = playerGlow;
      ctx.fill();
      ctx.beginPath();
      ctx.arc(player.x, player.y, PLAYER_RADIUS, 0, Math.PI * 2);
      const playerGradient = ctx.createRadialGradient(player.x - PLAYER_RADIUS * 0.3, player.y - PLAYER_RADIUS * 0.3, 0, player.x, player.y, PLAYER_RADIUS);
      playerGradient.addColorStop(0, '#60a5fa');
      playerGradient.addColorStop(1, '#3b82f6');
      ctx.fillStyle = playerGradient;
      ctx.fill();
      ctx.strokeStyle = '#fff';
      ctx.lineWidth = 3;
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(player.x - PLAYER_RADIUS * 0.3, player.y - PLAYER_RADIUS * 0.3, PLAYER_RADIUS * 0.25, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
      ctx.fill();
      ctx.restore();
    }

    // --- Draw Indicators/Overlays ---
    if (gameDataRef.current.dodgeStreak > 0 && currentGameState === 'playing') {
      ctx.fillStyle = '#4ade80';
      ctx.font = 'bold 24px Arial';
      ctx.textAlign = 'center';
      ctx.fillText(`${gameDataRef.current.dodgeStreak} Streak! 🔥`, GAME_CANVAS_W / 2, 40);
    }

    // Game Over Overlay
    if (currentGameState === 'finished') {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.85)';
      ctx.fillRect(0, 0, GAME_CANVAS_W, GAME_CANVAS_H);

      ctx.fillStyle = '#ff4444';
      ctx.font = 'bold 64px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.shadowColor = 'rgba(255, 68, 68, 0.5)';
      ctx.shadowBlur = 20;
      ctx.fillText('GAME OVER', GAME_CANVAS_W / 2, GAME_CANVAS_H / 2 - 60);
      ctx.shadowBlur = 0;

      ctx.font = 'bold 36px Arial';
      ctx.fillStyle = '#4ade80';
      ctx.shadowColor = 'rgba(74, 222, 128, 0.5)';
      ctx.shadowBlur = 15;
      ctx.fillText(`Dodged: ${gameDataRef.current.currentScore} projectiles`, GAME_CANVAS_W / 2, GAME_CANVAS_H / 2 + 20);
      ctx.shadowBlur = 0;

      ctx.font = '24px Arial';
      ctx.fillStyle = '#fff';
      ctx.fillText('Click "START GAME" to restart', GAME_CANVAS_W / 2, GAME_CANVAS_H / 2 + 80);
    }
  };

  // --- Game Loop ---
  const gameLoop = () => {
    gameLoopLogic();
    rafRef.current = requestAnimationFrame(gameLoop);
  };

  // --- Game Control ---
  const handleStartGame = () => {
    if (gameState === 'playing' || !mediaPipeLoaded) return;

    setScore(0);
    setHealth(100);
    setDifficulty(1);
    setGameState('playing');

    gameDataRef.current.projectiles = [];
    gameDataRef.current.particles = [];
    gameDataRef.current.dodgeStreak = 0;
    gameDataRef.current.levelDodges = 0; // Reset level dodge counter
    lastSpawnTimeRef.current = Date.now();
    spawnIntervalRef.current = INITIAL_SPAWN_INTERVAL;

    setStatus("Dodge incoming projectiles! Move your body to avoid them!");
  };

  // --- Effects (Script Loading and Cleanup) ---
  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
        document.body.appendChild(script);
      });
    };

    const loadMediaPipe = async () => {
      try {
        setStatus("Loading MediaPipe libraries...");
        await loadScript('https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.5/pose.js');
        await loadScript('https://cdn.jsdelivr.net/npm/@mediapipe/camera_utils@0.1/camera_utils.js');

        // Scripts are loaded, now set the flag to render the main UI
        setMediaPipeLoaded(true);
        setStatus("Libraries loaded. Requesting camera access...");
        setupMediaPipe();
      } catch (error) {
        console.error("MediaPipe Loading Error:", error);
        setStatus(`Error loading required libraries. Check your connection or console.`);
      }
    };

    loadMediaPipe();

    // --- CLEANUP FUNCTION (Crucial for preventing resource leaks) ---
    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      if (videoRef.current?.srcObject) {
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());
      }
      if (poseEstimatorRef.current) {
        poseEstimatorRef.current.close();
      }
    };
  }, [setupMediaPipe]);

  // --- Render ---
  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      background: '#0f172a',
      color: '#fff',
      fontFamily: 'Arial, sans-serif'
    }}>

      {/* Hidden Video element used by MediaPipe to capture frames */}
      <video ref={videoRef} style={{ display: 'none' }} playsInline muted />

      {/* RENDER FIX: Use simple HTML for the loading screen to avoid Ant Design component initialization errors */}
      {!mediaPipeLoaded ? (
        <div style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          padding: 50,
        }}>
          {/* Using raw HTML headings/text here */}
          <h2 style={{ color: '#fff', fontSize: '2em' }}>Loading Game Resources...</h2>
          <p style={{ color: '#94a3b8' }}>{status}</p>
          {/* Using a basic Ant Design progress circle is usually safe, but use <Progress> cautiously */}
          <Progress type="circle" percent={100} width={80} status="active" style={{ marginTop: 20 }} />
        </div>
      ) : (
        <>
          {/* LEFT PANEL */}
          <div style={{
            width: 320,
            background: '#1e293b',
            padding: 16,
            boxShadow: '4px 0 10px rgba(0,0,0,0.5)'
          }}>
            <Title level={3} style={{ color: '#f43f5e', marginTop: 0, marginBottom: 16 }}>
              🎯 Dodge & Weave
            </Title>

            <Text style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#e2e8f0',
              display: 'block',
              marginBottom: 16
            }}>
              {status}
            </Text>

            <div style={{ margin: '16px 0' }}>
              <Text style={{ color: '#94a3b8', fontSize: 12 }}>Health</Text>
              <Progress
                percent={health}
                strokeColor={{
                  '0%': '#ef4444',
                  '50%': '#f59e0b',
                  '100%': '#22c55e',
                }}
                status={health > 0 && gameState === 'playing' ? 'active' : health <= 0 ? 'exception' : 'normal'}
                showInfo={false}
              />
            </div>

            <Button
              onClick={handleStartGame}
              disabled={gameState === 'playing'}
              type="primary"
              danger
              block
              size="large"
              style={{ fontWeight: 'bold', marginBottom: 16 }}
            >
              {gameState === 'ready' || gameState === 'finished' ? 'START GAME' : 'PLAYING...'}
            </Button>

            <div style={{
              background: 'rgba(15, 23, 42, 0.5)', padding: 12, borderRadius: 8, marginBottom: 16
            }}>
              <div style={{ color: '#4ade80', fontSize: 32, fontWeight: 'bold', textAlign: 'center' }}>
                {score}
              </div>
              <Text style={{ color: '#94a3b8', fontSize: 12, display: 'block', textAlign: 'center' }}>
                Projectiles Dodged
              </Text>
            </div>

            <div style={{
              background: 'rgba(244, 63, 94, 0.2)', padding: 12, borderRadius: 8, marginBottom: 16, border: '1px solid rgba(244, 63, 94, 0.3)'
            }}>
              <Text style={{ color: '#f43f5e', fontSize: 20, fontWeight: 'bold', display: 'block', textAlign: 'center' }}>
                Level {difficulty}
              </Text>
              <Text style={{ color: '#94a3b8', fontSize: 12, display: 'block', textAlign: 'center' }}>
                Difficulty
              </Text>
            </div>

            <Text style={{ color: '#64748b', fontSize: 12, display: 'block', marginBottom: 8 }}>
              Camera Preview:
            </Text>

            <div style={{
              width: PREVIEW_W, height: PREVIEW_H, border: '2px solid #334155', borderRadius: '8px', overflow: 'hidden', background: '#000', marginBottom: 16
            }}>
              <video
                ref={previewVideoRef}
                style={{ transform: 'scaleX(-1)', width: '100%', height: '100%' }}
                playsInline
                muted
              />
            </div>

            <div style={{
              background: 'rgba(59, 130, 246, 0.1)', padding: 12, borderRadius: 8, border: '1px solid rgba(59, 130, 246, 0.3)'
            }}>
              <Text style={{ color: '#60a5fa', display: 'block', fontWeight: 'bold', marginBottom: 8, fontSize: 13 }}>
                How to Play:
              </Text>
              <Text style={{ color: '#cbd5e1', display: 'block', marginBottom: 4, fontSize: 12 }}>
                • Move your HEAD to control the blue circle
              </Text>
              <Text style={{ color: '#cbd5e1', display: 'block', marginBottom: 4, fontSize: 12 }}>
                • LEAN and DUCK to dodge projectiles
              </Text>
              <Text style={{ color: '#cbd5e1', display: 'block', marginBottom: 4, fontSize: 12 }}>
                • Each dodge = 1 point
              </Text>
              <Text style={{ color: '#cbd5e1', display: 'block', fontSize: 12 }}>
                • Getting hit = -10 health
              </Text>
            </div>
          </div>

          {/* RIGHT PANEL - GAME AREA */}
          <div style={{
            flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 20
          }}>
            <div style={{
              position: 'relative', width: GAME_CANVAS_W, height: GAME_CANVAS_H, boxShadow: '0 0 40px rgba(244, 63, 94, 0.3)', borderRadius: '12px', overflow: 'hidden', border: '2px solid rgba(244, 63, 94, 0.5)'
            }}>
              <canvas
                ref={canvasRef}
                width={GAME_CANVAS_W}
                height={GAME_CANVAS_H}
                style={{ borderRadius: '12px' }}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}